/** MODAL RESISTER && LOGIN */

import styled from "styled-components";

export const ModalEditRegsterStyled = styled.div`
	.card {
		margin: 1rem auto;
		padding: 10px 20px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		form {
			margin-top: 1rem;
			display: flex;
			flex-direction: column;
			row-gap: 1rem;
		}
		p {
			margin-top: 1rem;
			cursor: pointer;
		}
	}
`;
